import { t } from '../../localization';
import yoproductsServiceClient from '../../common/helpers/yoproducts-service-client';

const FREE = 0;

function formatPrice(price, currency, locale) {
  if (price === FREE) {
    return t('FREE');
  }

  const yoproducts = yoproductsServiceClient.get();

  return yoproducts.actions.formatPrice(price, locale, currency, {
    leadingCurrency: true,
  });
}

export default formatPrice;
